<template>
    <div>
        <LoadingOverlay
            :activeSyncProps="activeSync"
            :isFullPageProps="false"
            :hiddenProps="hidden"
        />
        <div v-show="currentUrl" class="gallery_frame">
            <img
                v-if="type === 'image'"
                :src="currentUrl"
                alt=""
            >
            <video v-else-if="type === 'video'" controls autoplay>
                <source :src="currentUrl" type="video/mp4" />
<!--              TODO: 자막도 고려해야 할까?? vtt 파일-->
                <track label="English" kind="captions" srclang="en" src="" default />
                {{ this.$t('alert.not_support_video') }}
            </video>
            <a v-else-if="type === 'download'" :href="currentUrl" download class="downLoad_file" target="_blank" style="display: flex; flex-direction: column;justify-content: center; align-items: center;">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                     width="64" height="64"
                     viewBox="0 0 172 172"
                     style=" fill:#000000;"><g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal"><path d="M0,172v-172h172v172z" fill="none"></path><g><path d="M133.03125,72.5625c14.78125,0 26.875,12.09375 26.875,26.875c0,14.78125 -12.09375,26.875 -26.875,26.875h-94.0625c-14.78125,0 -26.875,-12.09375 -26.875,-26.875c0,-14.78125 12.09375,-26.875 26.875,-26.875h6.71875v-6.71875c0,-22.30625 18.00625,-40.3125 40.3125,-40.3125c22.30625,0 40.3125,18.00625 40.3125,40.3125v6.71875z" fill="#ffffff"></path><path d="M86,143.78125c-2.28437,0 -4.03125,-1.74687 -4.03125,-4.03125v-40.3125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125c2.28437,0 4.03125,1.74688 4.03125,4.03125v40.3125c0,2.28438 -1.74688,4.03125 -4.03125,4.03125z" fill="#71c2ff"></path><path d="M86,143.78125c-1.075,0 -2.01562,-0.40312 -2.82188,-1.20937l-13.4375,-13.4375c-1.6125,-1.6125 -1.6125,-4.16563 0,-5.64375c1.6125,-1.6125 4.16563,-1.6125 5.64375,0l10.61562,10.61562l10.61563,-10.61562c1.6125,-1.6125 4.16562,-1.6125 5.64375,0c1.6125,1.6125 1.6125,4.16562 0,5.64375l-13.4375,13.4375c-0.80625,0.80625 -1.74688,1.20937 -2.82188,1.20937z" fill="#71c2ff"></path><g fill="#ffffff"><path d="M133.03125,130.34375h-13.4375c-2.28437,0 -4.03125,-1.74687 -4.03125,-4.03125c0,-2.28437 1.74688,-4.03125 4.03125,-4.03125h13.4375c12.63125,0 22.84375,-10.2125 22.84375,-22.84375c0,-12.63125 -10.2125,-22.84375 -22.84375,-22.84375h-6.71875c-2.28437,0 -4.03125,-1.74688 -4.03125,-4.03125v-6.71875c0,-20.02188 -16.25937,-36.28125 -36.28125,-36.28125c-20.02188,0 -36.28125,16.25937 -36.28125,36.28125v6.71875c0,2.28437 -1.74687,4.03125 -4.03125,4.03125h-6.71875c-12.63125,0 -22.84375,10.2125 -22.84375,22.84375c0,12.63125 10.2125,22.84375 22.84375,22.84375h13.4375c2.28438,0 4.03125,1.74688 4.03125,4.03125c0,2.28438 -1.74687,4.03125 -4.03125,4.03125h-13.4375c-17.06562,0 -30.90625,-13.84063 -30.90625,-30.90625c0,-17.06562 13.84063,-30.90625 30.90625,-30.90625h2.6875v-2.6875c0,-24.45625 19.8875,-44.34375 44.34375,-44.34375c24.45625,0 44.34375,19.8875 44.34375,44.34375v2.6875h2.6875c17.06563,0 30.90625,13.84063 30.90625,30.90625c0,17.06562 -13.84062,30.90625 -30.90625,30.90625z"></path></g></g></g></svg>
                <p>
                    {{ this.$t('alert.not_supported_file') }}
                    {{ this.$t('alert.click_to_download') }}
                </p>
            </a>
            <p v-else>{{ this.$t('alert.image_not_loaded') }}</p>
        </div>
    </div>
</template>
<script>
    import LoadingOverlay from '@/components/loadingOverlay';

    export default {
      name: 'contentsArea',
      components: {LoadingOverlay},
      props: ['srcProps', 'currentIndexProps'],
      data() {
        return {
          activeSync: true,
          hidden: 'hidden',
          currentUrl: '',
          type: 'image'
        }
      },
      watch: {
        currentIndexProps(newIndex) {
          this.currentUrl = this.srcProps[newIndex].imageUrl;
        }
      },
      methods: {},
      created() {
        this.currentUrl = this.srcProps[this.currentIndexProps].imageUrl;
      }
    }
</script>